export default function registerContactPicker(Alpine) {
  Alpine.data("signersForm", () => ({
    contacts: [],
    teamMembers: [],
    signers: [],
    currentUser: null,
    init() {
      try {
        this.contacts = JSON.parse(this.$el.dataset.contacts || "[]");
      } catch {
        this.contacts = [];
      }
      try {
        this.teamMembers = JSON.parse(this.$el.dataset.teamMembers || "[]");
      } catch {
        this.teamMembers = [];
      }
      try {
        this.currentUser = JSON.parse(this.$el.dataset.currentUser || "null");
      } catch {
        this.currentUser = null;
      }
      let initial;
      try {
        initial = JSON.parse(this.$el.dataset.initial || "[]");
      } catch {
        initial = [];
      }
      this.signers = initial.map((s) => ({
        role: s.role || "customer",
        userId: s.user_id || "",
        contactId: s.contact_id || "",
        name: s.name || "",
        email: s.email || "",
        mode: this.contacts.length && (s.contact_id || (!s.name && !s.email)) ? "pick" : "manual"
      }));
    },
    pickContact(idx, contactId) {
      const c = this.contacts.find((x) => String(x.id) === String(contactId));
      const s = this.signers[idx];
      if (!s) return;
      if (!c) {
        s.contactId = "";
        return;
      }
      s.contactId = String(c.id);
      s.name = c.name || "";
      s.email = c.email || "";
    },
    clearContact(idx) {
      const s = this.signers[idx];
      if (!s) return;
      s.contactId = "";
    },
    pickTeamMember(idx, userId) {
      const u = this.teamMembers.find((x) => String(x.id) === String(userId));
      const s = this.signers[idx];
      if (!s) return;
      if (!u) {
        s.userId = "";
        s.name = "";
        s.email = "";
        return;
      }
      s.userId = String(u.id);
      s.name = u.name || "";
      s.email = u.email || "";
    },
    setMode(idx, mode) {
      const s = this.signers[idx];
      if (!s) return;
      s.mode = mode;
      if (mode === "manual") {
        s.contactId = "";
      } else if (mode === "pick") {
        s.name = "";
        s.email = "";
      }
    },
    addCustomer() {
      this.signers.push({
        role: "customer",
        userId: "",
        contactId: "",
        name: "",
        email: "",
        mode: this.contacts.length ? "pick" : "manual"
      });
    },
    addCounterSigner() {
      const u = this.currentUser;
      this.signers.push({
        role: "counter_signer",
        userId: u ? String(u.id) : "",
        contactId: "",
        name: u ? u.name || "" : "",
        email: u ? u.email || "" : "",
        mode: "manual"
      });
    },
    addObserver() {
      this.signers.push({
        role: "observer",
        userId: "",
        contactId: "",
        name: "",
        email: "",
        mode: this.contacts.length ? "pick" : "manual"
      });
    },
    removeSigner(idx) {
      this.signers.splice(idx, 1);
    },
    customerCount() {
      return this.signers.filter((s) => s.role === "customer").length;
    },
    counterSignerCount() {
      return this.signers.filter((s) => s.role === "counter_signer").length;
    },
    canRemove(idx) {
      const s = this.signers[idx];
      if (!s) return false;
      if (s.role === "customer") return this.customerCount() > 1;
      return true;
    },
    contactNameFor(contactId) {
      const c = this.contacts.find((x) => String(x.id) === String(contactId));
      return c ? c.name : "";
    },
    contactEmailFor(contactId) {
      const c = this.contacts.find((x) => String(x.id) === String(contactId));
      return c ? c.email : "";
    }
  }));
}
